import {
  Backdrop,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import { Controller, useForm } from "react-hook-form";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import { useGetTokenOrLogout } from "../../../utils/token";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function EditTestPrepPackage({
  rowData,
  serviceId,
  setSelectedRowData,
}) {
  console.log("rowDatarowData", rowData);
  const getTokenOrLogout = useGetTokenOrLogout();
  const userId = localStorage.getItem("userId");

  const [serviceList, setServiceList] = useState([]);
  const [serviceName, setServiceName] = useState(null);
  const [subServiceList, setSubSurviceList] = useState([]);
  const [subserviceName, setSubserviceName] = useState([]);
  const [subserviceIds, setSubserviceIds] = useState([]);
  const [testTypeList, setTestTypeList] = useState([]);
  const [testTypeName, setTestTypeName] = useState(null);
  const [branchList, setBranchList] = useState([]);
  const [branchName, setBranchName] = useState([]);
  const [subServicePrograms, setSubServicePrograms] = useState(null);
  const [countryList, setCountryList] = useState([]);
  const [countryName, setCountryName] = useState(null);
  const [currency, setcurrency] = useState(rowData?.currency);

  const [programList, setProgramList] = useState(null);
  const [selectedClassList, setSelectedClassList] = useState([
    { id: 1, name: "Class 9", value: "class_9" },
    { id: 2, name: "Class 10", value: "class_10" },
    { id: 3, name: "Class 11", value: "class_11" },
    { id: 4, name: "Class 12", value: "class_12" },
  ]);
  const [classList, setClassList] = useState([]);
  const [className, setClassName] = useState(null);
  const [partnerUnivercity, setPartnerUniverCity] = useState(
    rowData?.partner_university || null,
  );
  const [nonpartnerUnivercity, setNonPartnerUniverCity] = useState(
    rowData?.non_partner_university,
  );
  const [changes, setChanges] = useState({});
  const [subTestTypeList, setSubtestTypeList] = useState([]);
  const [subtestType, setsubtestType] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isloading, setIsLoading] = useState(false);
  const [isTestivaMap, setIsTestivaMap] = useState(false);
  const [testivaPackages, setTestivaPackages] = useState([]);
  const [selectedTestivaPackage, setSelectedTestivaPackage] = useState(null);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    if (rowData) {
      ["reading", "listening", "writing", "speaking"].forEach((skill) => {
        setValue(`module_${skill}`, rowData[`module_${skill}`]);
        setValue(`question_${skill}`, rowData[`question_${skill}`]);
      });
    }
  }, [rowData]);

  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors },
    setError,
    reset,
  } = useForm({
    defaultValues: {
      currency: rowData?.currency,
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}service`);
        if (response.ok) {
          const data = await response.json();
          const fileeredServis = data.filter(
            (i) => i.service_name !== "Undefined",
          );
          const selectedService = data.find(
            (i) => i.id === rowData?.service_id?.id,
          );
          setServiceList(fileeredServis);
          setServiceName(selectedService);
          setValue("service_id", selectedService?.id || null);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handlechangeService = (e, value) => {
    setSubserviceName([]);
    setSubserviceIds([]);
    setSubServicePrograms(null);
    setClassName(null);
    setServiceName(value);
    setPartnerUniverCity(null);
    setNonPartnerUniverCity(null);
    setTestTypeName(null);
    setValue("service_id", value?.id);
    handleFieldChange("service_id", value?.id);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/subservicesbytesttypeid/${testTypeName?.id}`,
        );
        if (response.ok) {
          const data = await response.json();
          const filteredServices = data.filter(
            (i) => i.service_id === serviceName?.id,
          );
          const selectedSubservice = filteredServices.filter((i) =>
            rowData?.sub_service_id.includes(i.name),
          );
          const selectedSubserviceIds = selectedSubservice.map((i) => i.id);
          setSubSurviceList(filteredServices);
          setSubserviceName(selectedSubservice);
          setSubserviceIds(selectedSubserviceIds);
          setValue("sub_service_id", selectedSubserviceIds || []);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [testTypeName]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subservice-program`);
        if (response.ok) {
          const data = await response.json();
          const filterddata = data.filter((i) =>
            subserviceIds.includes(i.sub_service_id),
          );

          const selectedProgram = filterddata.find(
            (i) => i.id === rowData?.scholars_program_id?.id,
          );

          setProgramList(filterddata);
          setSubServicePrograms(selectedProgram || null);
          setValue("scholars_program_id", selectedProgram?.id || null);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [subserviceName]);

  console.log("subServicePrograms", subServicePrograms);

  const handlechangeprogram = (e, value) => {
    setClassName(null);
    setSubServicePrograms(value);
    setValue("scholars_program_id", value?.id);
    handleFieldChange("scholars_program_id", value?.id);
  };

  const allSubServiceList =
    subServiceList.length > 1
      ? [{ name: "Select All" }, ...subServiceList]
      : subServiceList;

  const handlechangeSubservice = (e, value) => {
    setSubServicePrograms(null);
    setClassName(null);
    setSubserviceName(value);
    setPartnerUniverCity(null);
    setNonPartnerUniverCity(null);

    if (value.some((option) => option.name === "Select All")) {
      const subserviceIds = subServiceList.map((i) => i.id);
      setSubserviceName(subServiceList);
      setSubserviceIds(subserviceIds);
      setValue("sub_service_id", subserviceIds);
      handleFieldChange("sub_service_id", subserviceIds);
    } else {
      const subserviceIds = value.map((i) => i.id);
      setSubserviceIds(subserviceIds);

      setValue("sub_service_id", subserviceIds);
      handleFieldChange("sub_service_id", subserviceIds);
    }
  };

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}advisordashboard/gettesttype`)
      .then((response) => response.json())
      .then((data) => {
        setTestTypeList(data);
        const selectedTestType = data.find(
          (i) => i.id === rowData?.test_type?.id,
        );
        setTestTypeName(selectedTestType);
        setValue("test_type", selectedTestType?.id || null);
      })
      .catch((error) => {
        console.error("Error fetching testtypes:", error);
      });
  }, []);

  const handleTestTypeChange = (e, value) => {
    setTestTypeName(value);
    setsubtestType(null);
    setSubtestTypeList([]);
    setSubserviceName([]);
    setSubserviceIds([]);
    setValue("sub_test_type_id", null);
    setValue("test_type", value.id);
    handleFieldChange("test_type", value.id);
    handleFieldChange("sub_test_type_id", null);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subtesttype`);
        if (response.ok) {
          const data = await response.json();
          const filterdSubTestType = data.find(
            (i) => i.id === rowData?.sub_test_type_id?.id,
          );

          setSubtestTypeList(data);
          setsubtestType(filterdSubTestType);
          // NOTE: this was missing before — sub_test_type_id was only ever
          // written into the RHF form state on user interaction, so an
          // untouched sub test type silently dropped out of getValues()
          // (and therefore out of the submit payload) on save.
          setValue("sub_test_type_id", filterdSubTestType?.id || null);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}country`)
      .then((response) => response.json())
      .then((data) => {
        const filteredcountry = data.filter(
          (i) => i.country_name === "India" || i.country_name === "Nepal",
        );
        setCountryList(filteredcountry);

        const selectedCountry = filteredcountry.find(
          (i) => i.country_name === rowData?.country_id?.country_name,
        );
        setCountryName(selectedCountry);
        setValue("country_id", selectedCountry?.id);
      })

      .catch((error) => {
        console.error("Error fetching testtypes:", error);
      });
  }, []);

  const handleCountryChange = (e, value) => {
    setBranchName([]);
    setValue("branch_id", []);
    setCountryName(value);

    setValue("country_id", value?.id);
    setcurrency(value?.currency_code);
    setValue("currency", value?.currency_code);
    handleFieldChange("country_id", value?.id);
    handleFieldChange("currency", value?.currency_code);
    handleFieldChange("branch_id", []);
  };

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}branch`)
      .then((response) => response.json())
      .then((data) => {
        const flteredBranch = data.filter(
          (i) => i.country_id === countryName?.id,
        );
        const selectedBranch = flteredBranch.filter((i) =>
          rowData?.branch_id.includes(i.branch_name),
        );

        setBranchList(flteredBranch);
        setBranchName(selectedBranch);
        setValue("branch_id", selectedBranch.map((i) => i.id) || null);
      })
      .catch((error) => {
        console.error("Error fetching testtypes:", error);
      });
  }, [countryName]);

  const allBranchList = [{ branch_name: "Select All" }, ...branchList];
  const handlebranchChange = (e, value) => {
    if (value.some((option) => option.branch_name === "Select All")) {
      const selectedBranch = branchList.map((i) => i.id);
      setBranchName(branchList);
      setValue("branch_id", selectedBranch);
      handleFieldChange("branch_id", selectedBranch);
    } else {
      setBranchName(value);
      setValue(
        "branch_id",
        value.map((i) => i.id),
      );
      handleFieldChange(
        "branch_id",
        value.map((i) => i.id),
      );
    }
  };

  useEffect(() => {
    if (subServicePrograms?.name === "Accelerated SUAP (for 11-12 class)") {
      const filteredClass = selectedClassList.filter(
        (i) => !["class_9", "class_10"].includes(i.value),
      );
      const selectedClass = filteredClass.find(
        (i) => i.value === rowData?.scholars_class,
      );
      setClassList(filteredClass);
      setClassName(selectedClass);
    } else {
      setClassList(selectedClassList);
      const selectedClass = selectedClassList.find(
        (i) => i.value === rowData?.scholars_class,
      );
      setClassName(selectedClass);
    }
  }, [subServicePrograms]);

  useEffect(() => {
    const fetchTestivaPackages = async () => {
      if (!isTestivaMap) return;

      const testivaSubTestTypeId = subtestType?.testiva_sub_test_type_id;

      if (!testivaSubTestTypeId) return;

      try {
        const token = getTokenOrLogout();
        if (!token) return;

        const response = await fetch(
          `${API_ENDPOINT}testiva-integration/get-package/${testivaSubTestTypeId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const result = await response.json();

        console.log("PACK", result);

        if (response.ok) {
          const packages =
            result?.flatMap((item) => item?.packages || []) || [];

          setTestivaPackages(packages);
        }
      } catch (error) {
        console.error("Error fetching Testiva packages", error);
      }
    };

    fetchTestivaPackages();
  }, [isTestivaMap, subtestType]);

  const handleChangeClass = (e, value) => {
    setClassName(value);
    setValue("scholars_class", value?.value);
    handleFieldChange("scholars_class", value?.value);
  };

  const onSubmit = async () => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      // FIX: previously this only spread `changes` — the map of fields the
      // user explicitly edited via handleFieldChange this session. Fields
      // that were only ever populated by setValue() in the initial-load
      // useEffects (branch_id, country_id, currency, sub_service_id,
      // scholars_class, etc.) were never added to `changes`, so an update
      // that only touched e.g. package_name silently omitted branch_id
      // (and friends) from the PUT body entirely — which the backend then
      // treated as "clear it". Pulling the full current snapshot via
      // getValues() first, then layering `changes` on top, guarantees every
      // field is present in the payload regardless of whether the user
      // touched it this session.
      const currentValues = getValues();
      const requestData = {
        ...currentValues,
        ...changes,
        user_id: parseInt(userId),
        package_id: rowData?.id,
        is_testiva_map: isTestivaMap ? 1 : 0,
        testiva_package_id: selectedTestivaPackage?.package_id,
        // duration: parseInt(data.duration, 10), // ensure it's an integer
        // original_price: parseInt(data.original_price, 10),
        // discounted_price: parseInt(data.discounted_price, 10),
        // non_partner_university: parseInt(data.non_partner_university, 10),
        // partner_university: parseInt(data.partner_university, 10),
      };
      setIsLoading(true);
      const response = await fetch(
        `${API_ENDPOINT}package/update/updatepackage`,
        {
          method: "PUT",
          headers,
          body: JSON.stringify(requestData),
        },
      );

      const result = await response.json();

      if (response.ok) {
        showSnackbar(result.message, "success");

        setTimeout(() => {
          window.location.reload();
        }, 1500);
        setIsLoading(false);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
        setIsLoading(false);
      } else if (response.status === 401) {
        showSnackbar("Unknown user!", "error");
        setIsLoading(false);
      } else if (response.status === 403) {
        showSnackbar("Unauthorized User!", "error");
        setIsLoading(false);
      } else if (response.status === 409) {
        showSnackbar("Duplicate Package Name", "error");
        setIsLoading(false);
      } else {
        showSnackbar(result.error, "error");
        setIsLoading(false);
      }
    } catch (error) {
      showSnackbar("Internal server error", "error");
      setIsLoading(false);
    }
  };

  //   Handle change field

  const handleFieldChange = (fieldName, value) => {
    setChanges((prevChanges) => ({
      ...prevChanges,
      [fieldName]: value,
    }));

    setSelectedRowData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));

    setValue(fieldName, value); // Update form value
  };

  useEffect(() => {
    if (rowData) {
      setIsTestivaMap(rowData?.is_testiva_map === 1);
      setValue("is_testiva_map", rowData?.is_testiva_map);
    }
  }, [rowData, setValue]);

  useEffect(() => {
    if (
      rowData?.is_testiva_map === 1 &&
      rowData?.testiva_package_id &&
      testivaPackages.length > 0
    ) {
      // rowData.testiva_package_id comes back from the API as an OBJECT
      // ({ package_id, name }), not a raw id. Comparing Number() of the
      // whole object always produced NaN, so this match never succeeded
      // and the field never prefilled. Pull the numeric id out first.
      const rowTestivaPackageId = rowData.testiva_package_id?.package_id;

      const selectedPackage = testivaPackages.find(
        (pkg) => Number(pkg.package_id) === Number(rowTestivaPackageId),
      );

      if (selectedPackage) {
        setSelectedTestivaPackage(selectedPackage);

        setValue("testiva_package_id", selectedPackage.package_id);
      }
    }
  }, [testivaPackages, rowData, setValue]);

  return (
    <>
      <Backdrop open={isloading} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} marginRight={2}>
          Updating...
        </Typography>
        <CircularProgress color="primary" />
      </Backdrop>
      <Grid item container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={Boolean(errors.service_id)}>
            <Typography variant="h5">
              Service{" "}
              <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
            </Typography>
            <Controller
              name="service_id"
              control={control}
              rules={{ required: "This is required field" }} // Add your validation rules here
              render={({ field }) => (
                <CustomAutocompleteComp
                  {...field}
                  fullWidth
                  disableClearable
                  size="small"
                  value={serviceName}
                  onChange={handlechangeService}
                  options={serviceList}
                  getOptionLabel={(option) => option.service_name}
                  tooltipContent={(option) => option.service_name}
                  error={Boolean(errors.service_id)}
                  helperText={errors.service_id && errors?.service_id?.message}
                  readOnly
                />
              )}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={Boolean(errors.test_type)}>
            <Typography variant="h5">
              Test Type{" "}
              <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
            </Typography>
            <Controller
              name="test_type"
              control={control}
              rules={{
                required:
                  serviceName?.id === 1 ? "This is required field" : false,
              }} // Add your validation rules here
              render={({ field }) => (
                <CustomAutocompleteComp
                  {...field}
                  fullWidth
                  size="small"
                  value={testTypeName}
                  onChange={handleTestTypeChange}
                  options={testTypeList}
                  getOptionLabel={(option) => option.name}
                  tooltipContent={(option) => option.name}
                  error={Boolean(errors.test_type)}
                  helperText={errors.test_type && errors?.test_type?.message}
                />
              )}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={Boolean(errors.sub_service_id)}>
            <Typography variant="h5">
              Sub Service{" "}
              <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
            </Typography>
            <Controller
              name="sub_service_id"
              control={control}
              rules={{ required: "This is required field" }} // Add your validation rules here
              render={({ field }) => (
                <CustomAutocompleteComp
                  {...field}
                  fullWidth
                  size="small"
                  multiple
                  disableClearable
                  noOptionsText={
                    testTypeName === null
                      ? "Select Test Type First"
                      : testTypeName !== null && subTestTypeList?.length === 0
                        ? "No Sub Test Type Available"
                        : ""
                  }
                  value={subserviceName}
                  onChange={handlechangeSubservice}
                  options={allSubServiceList}
                  getOptionLabel={(option) => option.name}
                  tooltipContent={(option) => option.name}
                  error={Boolean(errors.sub_service_id)}
                  helperText={
                    errors.sub_service_id && errors?.sub_service_id?.message
                  }
                />
              )}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={Boolean(errors.test_type)}>
            <Typography variant="h5">Sub Test Type </Typography>
            <Controller
              name="sub_test_type_id"
              control={control}
              render={({ field }) => (
                <CustomAutocompleteComp
                  {...field}
                  fullWidth
                  size="small"
                  value={subtestType}
                  onChange={(e, value) => {
                    setsubtestType(value);

                    // Reset Testiva Mapping when Sub Test Type changes
                    setIsTestivaMap(false);
                    setTestivaPackages([]);
                    setSelectedTestivaPackage(null);

                    setValue("is_testiva_map", 0);
                    setValue("testiva_package_id", null);
                    handleFieldChange("is_testiva_map", 0);
                    handleFieldChange("testiva_package_id", null);

                    setValue("sub_test_type_id", value?.id || null);
                    handleFieldChange("sub_test_type_id", value?.id || null);
                  }}
                  options={subTestTypeList}
                  getOptionLabel={(option) => option.name}
                  tooltipContent={(option) => option.name}
                />
              )}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isTestivaMap}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setIsTestivaMap(checked);
                  setValue("is_testiva_map", checked ? 1 : 0);
                  // Keep rowData/changes in sync too — without this, the
                  // rowData-driven sync effect below re-derives isTestivaMap
                  // from the (still-stale) rowData.is_testiva_map the next
                  // time any field changes (e.g. picking a Testiva package)
                  // and flips the checkbox back off.
                  handleFieldChange("is_testiva_map", checked ? 1 : 0);

                  if (!checked) {
                    setSelectedTestivaPackage(null);
                    setValue("testiva_package_id", null);
                    handleFieldChange("testiva_package_id", null);
                  }
                }}
              />
            }
            label="Map with Testiva Package"
          />
        </Grid>

        {isTestivaMap && (
          <Grid item xs={12} sm={12} md={6}>
            <FormControl fullWidth>
              <Typography variant="h5" mb={0.5}>
                Testiva Package
              </Typography>

              <Controller
                name="testiva_package_id"
                control={control}
                render={({ field }) => (
                  <CustomAutocompleteComp
                    {...field}
                    fullWidth
                    size="small"
                    value={selectedTestivaPackage}
                    onChange={(e, value) => {
                      setSelectedTestivaPackage(value);

                      const packageId = value?.package_id || null;

                      setValue("testiva_package_id", packageId);
                      handleFieldChange("testiva_package_id", packageId);
                    }}
                    options={testivaPackages}
                    getOptionLabel={(option) =>
                      option.package_name || option.name
                    }
                    tooltipContent={(option) =>
                      option.package_name || option.name
                    }
                  />
                )}
              />
            </FormControl>
          </Grid>
        )}

        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={Boolean(errors.package_name)}>
            <Typography variant="h5">
              Package Name{" "}
              <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
            </Typography>
            <Controller
              name="package_name"
              control={control}
              rules={{ required: "This is required field" }} // Add your validation rules here
              defaultValue={rowData?.package_name}
              render={({ field }) => (
                <CustomTextFieldComp
                  {...field}
                  fullWidth
                  size="normal"
                  onChange={(event) =>
                    handleFieldChange("package_name", event.target.value)
                  }
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    },
                  }}
                  error={Boolean(errors.package_name)}
                  helperText={
                    errors.package_name && errors?.package_name?.message
                  }
                />
              )}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth>
            <Typography variant="h5">
              Session
              {/* <span style={{ color: "red", fontSize: "0.7rem" }}>*</span> */}
            </Typography>
            <Controller
              name="duration"
              control={control}
              // rules={{ required: "This is required field" }} // Add your validation rules here
              defaultValue={rowData?.duration}
              render={({ field }) => (
                <CustomTextFieldComp
                  {...field}
                  fullWidth
                  type="number"
                  size="normal"
                  onChange={(event) =>
                    handleFieldChange("duration", event.target.value)
                  }
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    },
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={Boolean(errors.country_id)}>
            <Typography variant="h5">Country </Typography>
            <Controller
              name="country_id"
              control={control}
              rules={{ required: "This is required field" }} // Add your validation rules here
              render={({ field }) => (
                <CustomAutocompleteComp
                  {...field}
                  fullWidth
                  size="small"
                  disableClearable
                  value={countryName}
                  onChange={handleCountryChange}
                  options={countryList}
                  getOptionLabel={(option) => option.country_name}
                  tooltipContent={(option) => option.country_name}
                  error={Boolean(errors.country_id)}
                  helperText={errors.country_id && errors?.country_id?.message}
                />
              )}
            />
          </FormControl>
        </Grid>

        {countryName && (
          <>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth error={Boolean(errors.branch_id)}>
                <Typography variant="h5">currency</Typography>
                <Controller
                  name="currency"
                  control={control}
                  rules={{ required: "This is required field" }} // Add your validation rules here
                  render={({ field }) => (
                    <CustomTextFieldComp
                      {...field}
                      fullWidth
                      size="normal"
                      multiple
                      value={currency}
                      InputProps={{
                        readOnly: true,
                        style: { borderRadius: "10px" },
                      }}
                      error={Boolean(errors.currency)}
                      helperText={errors.currency && errors?.currency?.message}
                    />
                  )}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth error={Boolean(errors.branch_id)}>
                <Typography variant="h5">Branch</Typography>
                <Controller
                  name="branch_id"
                  control={control}
                  rules={{ required: "This is required field" }} // Add your validation rules here
                  render={({ field }) => (
                    <CustomAutocompleteComp
                      {...field}
                      fullWidth
                      size="small"
                      multiple
                      value={branchName}
                      onChange={handlebranchChange}
                      options={allBranchList}
                      getOptionLabel={(option) => option.branch_name}
                      tooltipContent={(option) => option.branch_name}
                      error={Boolean(errors.branch_id)}
                      helperText={
                        errors.branch_id && errors?.branch_id?.message
                      }
                    />
                  )}
                />
              </FormControl>
            </Grid>
          </>
        )}
        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={Boolean(errors.original_price)}>
            <Typography variant="h5">
              Original Price{" "}
              <span style={{ color: "red", fontSize: "0.7rem" }}>*</span>
            </Typography>
            <Controller
              name="original_price"
              control={control}
              rules={{ required: "This is required field" }} // Add your validation rules here
              defaultValue={rowData?.original_price}
              render={({ field }) => (
                <CustomTextFieldComp
                  {...field}
                  fullWidth
                  size="normal"
                  type="number"
                  onChange={(event) =>
                    handleFieldChange("original_price", event.target.value)
                  }
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    },
                  }}
                  error={Boolean(errors.original_price)}
                  helperText={
                    errors.original_price && errors?.original_price?.message
                  }
                />
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth>
            <Typography variant="h5">Discounted Price </Typography>
            <Controller
              name="discounted_price"
              control={control}
              // rules={{ required: true }} // Add your validation rules here
              defaultValue={rowData?.discounted_price}
              render={({ field }) => (
                <CustomTextFieldComp
                  {...field}
                  fullWidth
                  size="normal"
                  type="number"
                  onChange={(event) =>
                    handleFieldChange("discounted_price", event.target.value)
                  }
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    },
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={Boolean(errors.payable_installment)}>
            <Typography variant="h5">Payable Installments </Typography>
            <Controller
              name="payable_installment"
              control={control}
              // rules={{ required: true }} // Add your validation rules here
              defaultValue={rowData?.payable_installment}
              render={({ field }) => (
                <Select
                  {...field}
                  size="normal"
                  style={{ borderRadius: "10px" }}
                  onChange={(event) =>
                    handleFieldChange("payable_installment", event.target.value)
                  }
                >
                  <MenuItem value={1}>No installments</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                </Select>
              )}
            />
          </FormControl>
        </Grid>

        {/* <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth error={Boolean(errors.mock_tests)}>
            <Typography variant="h5">Mock Tests </Typography>
            <Controller
              name="mock_tests"
              control={control}
              defaultValue={rowData?.mock_tests}
              render={({ field }) => (
                <CustomTextFieldComp
                  {...field}
                  fullWidth
                  size="normal"
                  type="number"
                  onChange={(event) =>
                    handleFieldChange("mock_tests", event.target.value)
                  }
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    },
                  }}
                  error={Boolean(errors.mock_tests)}
                  helperText={errors.mock_tests && errors?.mock_tests?.message}
                />
              )}
            />
          </FormControl>
        </Grid> */}

        {/* <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth>
            <Typography variant="h5">
              Module-Wise Tests
            </Typography>
            <Controller
              name="module_wise_questions"
              control={control}
              defaultValue={rowData?.module_wise_questions}
              render={({ field }) => (
                <CustomTextFieldComp
                  {...field}
                  fullWidth
                  type="number"
                  size="normal"
                  onChange={(event) =>
                    handleFieldChange("module_wise_questions", event.target.value)
                  }
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    },
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>

         <Grid item xs={12} sm={12} md={6}>
          <FormControl fullWidth>
            <Typography variant="h5">
              Question-Wise Tests (For PTE Packages)
            </Typography>
            <Controller
              name="question_wise_questions"
              control={control}
              defaultValue={rowData?.question_wise_questions}
              render={({ field }) => (
                <CustomTextFieldComp
                  {...field}
                  fullWidth
                  type="number"
                  size="normal"
                  onChange={(event) =>
                    handleFieldChange("question_wise_questions", event.target.value)
                  }
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    },
                  }}
                />
              )}
            />
          </FormControl>
        </Grid> */}

        {/* ================= MODULE-WISE ================= */}
        {/* <Grid item xs={12}>
          <Typography variant="h5">Module-Wise Tests</Typography>
          <Divider />
        </Grid>

        {["reading", "listening", "writing", "speaking"].map((skill) => (
          <Grid item xs={12} md={3} key={`module_${skill}`}>
            <FormControl fullWidth>
              <Typography>{skill.toUpperCase()}</Typography>
              <Controller
                name={`module_${skill}`}
                control={control}
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    type="number"
                    size="normal"
                    fullWidth
                    onChange={(e) => {
                      field.onChange(e); // update react-hook-form
                      handleFieldChange(`module_${skill}`, e.target.value);
                    }}
                  />
                )}
              />
            </FormControl>
          </Grid>
        ))} */}

        {/* ================= QUESTION-WISE (PTE) ================= */}
        {/* <Grid item xs={12}>
          <Typography variant="h5">Question-Wise Tests (PTE)</Typography>
          <Divider />
        </Grid>

        {["reading", "listening", "writing", "speaking"].map((skill) => (
          <Grid item xs={12} md={3} key={`question_${skill}`}>
            <FormControl fullWidth>
              <Typography>{skill.toUpperCase()}</Typography>
              <Controller
                name={`question_${skill}`}
                control={control}
                render={({ field }) => (
                  <CustomTextFieldComp
                    {...field}
                    type="number"
                    size="normal"
                    fullWidth
                    onChange={(e) => {
                      field.onChange(e); // update react-hook-form
                      handleFieldChange(`question_${skill}`, e.target.value);
                    }}
                  />
                )}
              />
            </FormControl>
          </Grid>
        ))} */}

        <Grid item xs={12} sm={12} md={12}>
          <FormControl fullWidth error={Boolean(errors.description)}>
            <Typography variant="h5">Description </Typography>
            <Controller
              name="description"
              control={control}
              defaultValue={rowData?.description}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  onChange={(event) =>
                    handleFieldChange("description", event.target.value)
                  }
                  multiline
                  rows={6}
                  size="normal"
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    },
                  }}
                  error={Boolean(errors.description)}
                  helperText={
                    errors.description && errors?.description?.message
                  }
                />
              )}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} textAlign="end">
          <Button
            variant="contained"
            size="medium"
            onClick={handleSubmit(onSubmit)}
          >
            Submit
          </Button>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
